
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

const columns = [
  
  { field: "shop", label: "SHOP", align: "left" },
  { field: "direct", label: "Direct Labour ", align: "right" },
  { field: "actual", label: "Actual O/C Labour ", align: "right" },
  { field: "total", label: "Total Labour as perTime Sheet", align: "right" },
 // { field: "blank", label: "" },

];

export default function WGRTable({ rows }) {
  return (
    <TableContainer>
      <Table
        size="small"
        stickyHeader
      >
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.field}
                align={column.align}
                sx={{
                  fontWeight: 700,
                  bgcolor: "grey.200",
                  whiteSpace: "nowrap",
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row, index) => {

             const totalLabour =
              Number(row["DIRECT LABOUR"] || 0) +
              Number(row["ACTUAL ON COST LABOUR"] || 0);


             // console.log(totalLabour);

            return (
      <TableRow
        key={index}
        hover
        sx={{
          "&:nth-of-type(even)": {
            bgcolor: "grey.50",
          },
        }}
      >

              <TableCell align="left" sx={{ paddingLeft: "100px" }}>
                {row.SHOPCODE}
              </TableCell>

              <TableCell align="right">
                <CurrencyCell
                  value={row["DIRECT LABOUR"]}
                />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell
                  value={row["ACTUAL ON COST LABOUR"]}
                />
              </TableCell>


              <TableCell align="right">
                <CurrencyCell
                  value={totalLabour}
                />
              </TableCell>

            </TableRow>
          )})}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

